module.exports = __webpack_public_path__ + "img/bg-stadiumfacts.1d115c31.jpg";